<div class="tw:flex tw:min-h-screen tw:flex-col tw:overflow-x-clip tw:bg-white">
	<app-header />
	<main class="tw:flex-1">
		<router-outlet />
	</main>
	<app-footer />
</div>

<!-- Tombol WhatsApp mengambang -->
<a
	[href]="waLink"
	target="_blank"
	rel="noopener"
	aria-label="Chat WhatsApp"
	class="tw:fixed tw:bottom-5 tw:right-5 tw:z-40 tw:flex tw:items-center tw:gap-2 tw:rounded-full tw:bg-[#25D366] tw:px-4 tw:py-3.5 tw:text-sm tw:font-semibold tw:text-white tw:shadow-lg tw:shadow-black/20 tw:transition-transform tw:hover:scale-105">
	<fa-icon ngSkipHydration [icon]="['fab', 'whatsapp']" class="tw:text-xl" />
	<span class="tw:hidden tw:sm:inline">WhatsApp</span>
</a>
